import React from 'react';
import { getShopUrl } from '../../utils/utils';

const safeJson = (data) => JSON.stringify(data).replace(/</g, '\\u003c');

function buildBreadcrumbList(cityName) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Accueil',
        item: 'https://roulezjeunesse.com',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'Annuaire',
        item: 'https://roulezjeunesse.com/annuaire-velo',
      },
      {
        '@type': 'ListItem',
        position: 3,
        name: cityName,
      },
    ],
  };
}

function buildItemList(cityName, shops) {
  return {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: `Ateliers vélo à ${cityName}`,
    numberOfItems: shops.length,
    itemListElement: shops.map((shop, index) => {
      const path = getShopUrl(shop);
      const url =
        path === '#' ? undefined : `https://roulezjeunesse.com${path}`;
      return {
        '@type': 'ListItem',
        position: index + 1,
        ...(url ? { url } : {}),
      };
    }),
  };
}

export default function CityJsonLd({ cityName, shops }) {
  if (!cityName) return null;

  const breadcrumb = buildBreadcrumbList(cityName);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: safeJson(breadcrumb) }}
      />
      {shops && shops.length > 0 && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: safeJson(buildItemList(cityName, shops)),
          }}
        />
      )}
    </>
  );
}
